import React from 'react';
import PropTypes from 'prop-types';

import {
	FormControl,
	FormHelperText,
	TextField,
} from '@material-ui/core';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Autocomplete as AutocompleteMaterial } from '@material-ui/lab';

import { useTranslation } from '@common/utils';

function FormAutocomplete({ handleBlur, values, touched, errors, setFieldValue, prop, options, label, required }) {
	const tr = useTranslation();

	return (
		<FormControl fullWidth>
			<>
				<AutocompleteMaterial
					getOptionSelected={(option, value) => option.id === value.id}
					options={options}
					name={prop}
					onBlur={handleBlur(prop)}
					onChange={(e, o) => setFieldValue(prop, o ? o.value : '')}
					value={typeof values[prop] !== 'undefined'
						? options.reduce((res, option) => {
							if (option.value === values[prop]) {
								return option;
							}

							return res;
						}, null)
						: ''
					}
					clearOnEscape={true}
					popupIcon={<ExpandMoreIcon />}
					getOptionLabel={option => option.label || ''}
					renderInput={params => (
						<TextField
							{...params}
							required={required}
							label={tr(label)}
							variant="outlined"
							fullWidth
							error={touched[prop] && Boolean(errors[prop])}
						/>
					)}
				/>
				{touched[prop] && Boolean(errors[prop]) && (
					<FormHelperText style={{ marginLeft: '14px' }} error={true}>
						{errors[prop]}
					</FormHelperText>
				)}
			</>
		</FormControl>
	);
}

FormAutocomplete.propTypes = {
	handleBlur: PropTypes.func,
	touched: PropTypes.object,
	errors: PropTypes.object,
	values: PropTypes.object,
	setFieldValue: PropTypes.func,
	prop: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	options: PropTypes.array.isRequired,
	required: PropTypes.bool,
};

export default FormAutocomplete;
